module.exports = __webpack_public_path__ + "img/7_140.420496b4.png";